<template>
    <div class="wrapper">
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'Redirect',
    data: () => ({
        isLoading: true,
    }),
    methods: {
        async transportAuthToken() {
            this.isLoading = true;
            const token = this.$route.params.token;

            if (token) {

                try {
                    axios.post(`${process.env.API_ROOT}/transport-auth-token`, { token }).
                        then((response) => {
                            const data = response.data;
                            localStorage.setItem("_indecx", JSON.stringify(data));
                            this.$router.push('/dashboard/');
                        });

                    this.isLoading.value = false;

                } catch (error) {
                    this.$router.push('/login');
                    this.isLoading.value = false;
                }

            } else {
                this.$router.push('/login');
                this.isLoading.value = false;
            }
        }

    },
    created() {
        this.transportAuthToken();
    },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/pages/home/redirect/index.vue